<div class="lx-popup" [class.lx-popup--active]="active">
  <div class="lx-popup__close" (click)="closePopupEvent()">
    <i class="pi pi-times lx-popup__close--icon"></i>
  </div>
  <div class="lx-popup__container" [style.maxWidth]="maxWidth" [style.width]="width">
    <h2 class="lx-popup__title">{{ title }}</h2>
    <ng-content></ng-content>
  </div>
</div>
